import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
export var packageStore = {
  namespaced: true,
  state: {
    selectPackage: {}
  },
  mutations: {
    setSelectPackage: function setSelectPackage(state, _a) {
      var list = _a.list,
          activityId = _a.activityId;
      Vue.set(state.selectPackage, activityId, list);
    }
  },
  actions: {
    getSelectPackage: function getSelectPackage(_a, _b) {
      var commit = _a.commit;
      var activityId = _b.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var res, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/package_gift/package_select', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              res = _c.sent();
              rdata = res.data;

              if (rdata.status === 0) {
                commit('setSelectPackage', {
                  list: rdata.data,
                  activityId: activityId
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    packageUpgrade: function packageUpgrade(_a, _b) {
      var commit = _a.commit;
      var activityId = _b.activityId,
          packageId = _b.packageId;
      return __awaiter(this, void 0, void 0, function () {
        var res, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/package_gift/upgrade', {
                activity_id: activityId,
                package_id: packageId
              })];

            case 1:
              res = _c.sent();
              rdata = res.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};